module.exports = __webpack_public_path__ + "media/images/avatar/12-85d81d1cdee8ce1bde35b8d8d5207277.svg";